"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Key: function() {
        return Key;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Key = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.00019 8C9.00019 4.13401 12.1342 1 16.0002 1C19.8662 1 23.0002 4.13401 23.0002 8C23.0002 11.866 19.8662 15 16.0002 15C15.5378 15 15.0849 14.955 14.646 14.8689C14.6058 14.861 14.5737 14.8642 14.5547 14.8692C14.546 14.8715 14.5414 14.8737 14.5396 14.8748L12.7073 16.7071C12.5198 16.8946 12.2654 17 12.0002 17H11.0002V18C11.0002 18.5523 10.5525 19 10.0002 19H9.00019V20C9.00019 20.5523 8.55248 21 8.00019 21H7.00019V22C7.00019 22.5523 6.55248 23 6.00019 23H3.00019C1.89562 23 1.00019 22.1046 1.00019 21V18.4142C1.00019 17.8838 1.2109 17.3751 1.58598 17L9.1254 9.46058C9.12647 9.45875 9.12869 9.45419 9.13099 9.44552C9.13604 9.42649 9.13915 9.39436 9.13128 9.35422C9.04517 8.9153 9.00019 8.46241 9.00019 8ZM9.00019 17V16C9.00019 15.4477 9.44791 15 10.0002 15H11.586L13.1264 13.4595C13.6603 12.9257 14.3979 12.7821 15.031 12.9063C15.3438 12.9677 15.6677 13 16.0002 13C18.7616 13 21.0002 10.7614 21.0002 8C21.0002 5.23858 18.7616 3 16.0002 3C13.2388 3 11.0002 5.23858 11.0002 8C11.0002 8.33248 11.0325 8.65642 11.0939 8.96919C11.2181 9.60228 11.0745 10.3399 10.5407 10.8737L3.00019 18.4142V21H5.00019V20C5.00019 19.4477 5.44791 19 6.00019 19H7.00019V18C7.00019 17.4477 7.44791 17 8.00019 17H9.00019ZM15.0002 8C15.0002 7.44772 15.4479 7 16.0002 7H16.0102C16.5625 7 17.0102 7.44772 17.0102 8C17.0102 8.55228 16.5625 9 16.0102 9H16.0002C15.4479 9 15.0002 8.55228 15.0002 8Z",
        fill: "currentColor"
    })
}), "Key");
const _default = Key;
